export default "__VITE_ASSET__b5da7e57__"